import React from "react";

import { isDatasetIdentifier } from "utils/utils";
import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { useGetRecentData } from "api/api-hooks/datasets-hooks";

type DatasetProps = {
  value: string | null;
  changeHandler: (receivedValue: string | null) => void;
  isInEditMode: boolean;
  decimalPlaces?: number;
};

const Dataset: React.FC<DatasetProps> = ({ changeHandler, value, isInEditMode, decimalPlaces }) => {
  if (isInEditMode) {
    return <DatasetDropdown value={value} onChange={changeHandler} hideButtons />;
  }
  const dataset = isDatasetIdentifier(value ?? "");
  if (!dataset) return "-";

  return <DatasetDisplay identifier={value!} decimalPlaces={decimalPlaces} />;
};

const DatasetDisplay = ({
  identifier,
  decimalPlaces,
}: {
  identifier: string;
  decimalPlaces?: number;
}) => {
  const { data, isLoading } = useGetRecentData([identifier!], {
    options: { enabled: !!identifier },
  });
  const value = data?.[0].data?.[0]?.value;
  return (
    <div
      className="p-inputtext"
      style={{
        border: "none",
        backgroundColor: "inherit",
        color: "inherit",
        whiteSpace: "pre-wrap",
      }}
    >
      {isLoading && <div className="pi pi-spin pi-spinner" />}
      {!value && !isLoading && <>&#8208;</>}
      {value?.toFixed(decimalPlaces ?? 2)}
    </div>
  );
};

export default Dataset;
